var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-primary mt-2 mb-4",on:{"click":function($event){$event.preventDefault();return _vm.$emit('click')}}},[_c('span',{staticClass:"fa fa-angle-left mr-1"}),_vm._v(" "),_c('span',[_vm._v("Back")])])
}
var staticRenderFns = []

export { render, staticRenderFns }